document.addEventListener("DOMContentLoaded", function () {
  // ✅ Eliminar el after molesto del banner 1
  const style = document.createElement("style");
  style.innerHTML = `
    .media-grid-item-item_qgprnF::after {
      content: none !important;
      display: none !important;
      pointer-events: none !important;
    }
  `;
  document.head.appendChild(style);
  console.log("✅ ::after del banner 1 desactivado correctamente");

  // ✅ Banner 1 – click funcional después de quitar el ::after
  const tryApplyClickBanner1 = setInterval(() => {
    const banner1 = document.querySelector(".media-grid-item-item_qgprnF");

    if (banner1) {
      banner1.style.cursor = "pointer";

      // Evitamos duplicar listeners
      if (!banner1.classList.contains("click-applied")) {
        banner1.addEventListener("click", () => {
          window.location.href = "https://ferconutrition.com/collections/best-sellers";
        });
        banner1.classList.add("click-applied");
        console.log("✅ Click aplicado correctamente al banner 1");
      }

      clearInterval(tryApplyClickBanner1);
    }
  }, 300);

  // ✅ Banners 2 y 3
  const redirectMap = {
    "media-grid-item-item_EBMXFn": "https://ferconutrition.com/collections/linea-natural",
    "media-grid-item-item_zB8reX": "https://ferconutrition.com/collections/linea-2-0-healthyfusion"
  };

  Object.entries(redirectMap).forEach(([className, url]) => {
    const wrapper = document.querySelector("." + className);
    if (!wrapper) {
      console.warn("No se encontró:", className);
      return;
    }

    wrapper.style.cursor = "pointer";
    wrapper.addEventListener("click", () => {
      window.location.href = url;
    });
  });
});
